import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";

export default function ErrorMessage({error}: {error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined}) {
  if (!error || !error.message) return null;

  return (
    <div className='absolute text-xs font-semibold text-ev-red'>{error?.message?.toString()}</div>
  );
}
